import { render, staticRenderFns } from "./MemberBody.vue?vue&type=template&id=32de2eed&scoped=true&"
import script from "./MemberBody.vue?vue&type=script&lang=ts&"
export * from "./MemberBody.vue?vue&type=script&lang=ts&"
import style0 from "./MemberBody.vue?vue&type=style&index=0&id=32de2eed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de2eed",
  null
  
)

export default component.exports